import { useLocation, useNavigate, useNavigationType, type NavigateFunction } from "react-router-dom";
import { useRoutes } from "react-router-dom";
import { useEffect, useLayoutEffect } from "react";
import appRoutes, { payHostRoutes } from "./config";
import { isPayHost } from "../lib/payHost";

let navigateResolver: (navigate: ReturnType<typeof useNavigate>) => void;

declare global {
  interface Window {
    REACT_APP_NAVIGATE: ReturnType<typeof useNavigate>;
  }
}

export const navigatePromise = new Promise<NavigateFunction>((resolve) => {
  navigateResolver = resolve;
});

/**
 * Opens every new page at the top. BrowserRouter keeps the old scroll position, so a
 * footer link would land partway down the next page. "instant" overrides the global
 * smooth scrolling, which would otherwise animate the jump from the old position.
 * Back/forward (POP) keeps the browser's own restoration, and hash links scroll to their
 * anchor instead.
 */
function useScrollToTopOnNavigate() {
  const { pathname, hash } = useLocation();
  const navigationType = useNavigationType();
  useLayoutEffect(() => {
    if (navigationType === "POP" || hash) return;
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname, hash, navigationType]);
}

export function AppRoutes() {
  const element = useRoutes(isPayHost() ? payHostRoutes : appRoutes);
  const navigate = useNavigate();
  useScrollToTopOnNavigate();
  useEffect(() => {
    window.REACT_APP_NAVIGATE = navigate;
    navigateResolver(window.REACT_APP_NAVIGATE);
  });
  return element;
}
